import { Modal, ModalOverlay, ModalContent, ModalFooter, ModalBody } from '@chakra-ui/react'

import { SocialShareArea } from '@/components/SocialShareArea'

type SocialShareAreaModalProps = {
  url: string
  isOpen: boolean
  onClose: () => void
}

export const SocialShareAreaModal = ({ url, isOpen, onClose }: SocialShareAreaModalProps) => {
  return (
    <Modal trapFocus={false} isOpen={isOpen} size={['xs', 'md', 'md']} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalBody>
          <SocialShareArea currentUrl={url} />
        </ModalBody>
        <ModalFooter></ModalFooter>
      </ModalContent>
    </Modal>
  )
}
